/**
 * Module for Custom Rep/Covering Cell.
 * @module src/Events/EventsList
 */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import './index.scss';

interface Reps {
  type: string;
}
interface Props {
  item?: Reps;
}

const InventoryReturnTypeCell: FC<Props> = ({
  item = {
    type: '',
    coveringReps: '',
  },
}) => {
  const { type } = item;
  return (
    <DataTableCell title={type === 'Pickup Return' ? 'Pickup' : 'Standard'}>
      <p className="wrap-text font-12">{type === 'Pickup Return' ? 'Pickup' : 'Standard'}</p>
    </DataTableCell>
  );
};

/** Custom Rep/Covering cell */
export default InventoryReturnTypeCell;
